import { render, staticRenderFns } from "./CoozzySearchIcon.vue?vue&type=template&id=1229c600&scoped=true"
import script from "./CoozzySearchIcon.vue?vue&type=script&lang=js"
export * from "./CoozzySearchIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzySearchIcon.vue?vue&type=style&index=0&id=1229c600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1229c600",
  null
  
)

export default component.exports